// app/javascript/projects/components/ProjectsDisplay.jsx
import React from 'react';
import { useTeamModal } from 'contexts/TeamModalContext';
import BillingModalMainWrapper from './BillingModalMainWrapper';

import {
  PAUSE_FEEDBACK_SURVEY,
} from 'constants/AccountPageConstants'

function BillingModalMainRenew ({ subscription = {}, children, postDiv }) {
  const { navigateToPage } = useTeamModal();
  
  const cancelSubscription = () =>
  {
    navigateToPage(PAUSE_FEEDBACK_SURVEY)
  }

  return (<BillingModalMainWrapper
    subscription={subscription}
    buttonText="Cancel Subscription"
    onButtonClick={cancelSubscription}
    postDiv={postDiv}
    >
      {children}
  </BillingModalMainWrapper>)
}

export default BillingModalMainRenew;
